// extracted by mini-css-extract-plugin
export default {"mainDiv":"Table_mainDiv__5qFEo","loadingContainer":"Table_loadingContainer__wWQAN"};